import { render } from "./approved.svg?vue&type=template&id=17e9fa19"
const script = {}
script.render = render

export default script